import { client } from "api";
import { Company } from "models/Company";
import { CompanyOffice } from "models/CompanyOffice";

export type CreateOfficeRequest = { companyId: Company["id"] } & Omit<CompanyOffice, "id">;

export type CreateOfficeResponse = CompanyOffice[];

export const createOffice = ({ companyId, ...officeData }: CreateOfficeRequest) =>
  client.post<CreateOfficeResponse>(`/company/${companyId}/offices`, officeData).then((res) => res.data);
